import { Component } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-contact',
  imports: [],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.sass'
})
export class ContactComponent {
  readonly contactEmail = environment.contactEmail;
  readonly linkedInProfileUrl = environment.linkedInProfileUrl;
  readonly contactAvatarUrl = environment.contactAvatarUrl;
  readonly siteOwnerName = environment.siteOwnerName;
}
